// extracted by mini-css-extract-plugin
export default {"container":"CNclde","button":"qUhYcf","icon":"REalhn","tooltipInner":"DHQ8GP","tooltipText":"naDsUv","tooltip":"UfFxnV"};